import React from 'react';
import CarrosselImages from '../component/carouselComponent';
import NestedBtn from '../component/nestedBtn';
import { getBtnData, getOneItemColleciton, deleteData } from '../api/Api';
import MenuButton from '../component/menuHamburguerButton';
import RequestModal from '../component/Request/requestModal.js';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import style from '../assets/styles/mainMenu.module.scss';
import { common } from '@mui/material/colors';
import { GlobalContext } from '../GlobalContext';
import { CheckUser, updatingSideDishes } from '../Helpers/Helpers.js';
import { getFirestore, collection } from 'firebase/firestore';
import { addDoc } from '../api/FirestoreInterceptor';
import WarningMessage from '../component/WarningMessages';
import { db } from '../config-firebase/firebase.js';
import {
  useEnsureAnonymousUser,
  getAnonymousUser,
} from '../Hooks/useEnsureAnonymousUser.js';
import SubHeaderCustomer from '../component/subHeaderCustomer.js';
import { onSnapshot } from 'firebase/firestore';
import { AdminBackdoor } from '../Hooks/useAdminBackdoor.js';

function MainMenu() {
  // const [displayForm, setDisplayForm] = React.useState(false);
  const [menuButton, setMenuButton] = React.useState([]);
  const [dishes, setDishes] = React.useState([]);
  const [nameClient, setNameClient] = React.useState('');
  const containerRef = React.useRef(null);
  const global = React.useContext(GlobalContext);
  const [logoutAdminPopup, setLogoutAdminPopup] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { tableNumber: routeTable } = useParams();

  const normalizeTable = React.useCallback((val) => {
    if (!val) return null;
    const str = String(val).trim();
    const match = str.match(/^mesa[-_]?(\d+)$/i);
    return match ? match[1] : str;
  }, []);

  const searchParams = new URLSearchParams(location.search);
  const queryTable = searchParams.get('mesa') || searchParams.get('table') || searchParams.get('tableNumber');
  const rawTable = routeTable || queryTable;
  const tableNumber = normalizeTable(rawTable);

  React.useEffect(() => {
    if (tableNumber) {
      localStorage.setItem('tableNumber', tableNumber);
      localStorage.setItem('tableTimestamp', Date.now().toString());
      if (!routeTable && queryTable) {
        navigate(`/${tableNumber}`, { replace: true });
      }
    } else {
      // Se não há tableNumber na URL, checa se a sessão expirou por inatividade (4 horas)
      const storedTime = localStorage.getItem('tableTimestamp');
      const fourHoursMs = 4 * 60 * 60 * 1000;
      if (storedTime && Date.now() - Number(storedTime) > fourHoursMs) {
        localStorage.removeItem('tableNumber');
        localStorage.removeItem('tableTimestamp');
      }
    }
    global.setIsInitialLoad(false);
  }, [tableNumber, routeTable, queryTable, global.isInitialLoad, navigate]);

  React.useEffect(() => {
    checkToten(); // Verifica se o toten existe no localStorage e define o estado global isToten
    const unsubscribe = onSnapshot(collection(db, 'item'), (snapshot) => {
      const dishes = snapshot.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter((dish) => dish.category !== 'hide');
      setDishes(dishes); // atualiza automaticamente
    });

    return () => unsubscribe();
  }, []);

  const checkToten = () => {
    const totenExist = localStorage.getItem('isToten') === 'true';
    if (!totenExist) {
      global.setIsToten(false);
      if (!global.authorizated) {
        CheckLogin(global.packageTier);
      }
    } else {
      global.setIsToten(true);
      CheckLogin(global.packageTier);
    }
  };

  React.useEffect(() => {
    if (!global.isToten) {
      if (!global.authorizated) {
        CheckLogin(global.packageTier);
      }
    }
    fetchData();
  }, [global.authorizated]);

  const fetchData = async () => {
    try {
      const data = await getBtnData('button');
      const filteredMenuButton = Array.isArray(data)
        ? data.filter((btn) => btn.parent !== 'hide')
        : [];
      setMenuButton(filteredMenuButton);
      grabClient();
    } catch (error) {
      console.error('Erro fetching data', error);
    }
  };

  React.useEffect(() => {
    if (global.isToten === null) return; // Espera até que tenha um valor válido

    if (!global.authorizated) {
      CheckLogin(global.packageTier);
    }
  }, [global.isToten]); // Reexecuta quando global.isToten for atualizado

  async function CheckLogin(packageTier) {
    const userId = await CheckUser('userMenu', global.isToten, packageTier);
    const tableStored = localStorage.getItem('tableNumber');
    if (userId === '/' && tableStored) {
      navigate(`/${tableStored}`);
    } else {
      navigate(userId);
    }
  }

  // const logToAnounimousInToten = () => {
  const noCustomer = {
    name: 'anonimo',
    phone: '777',
    birthday: '77',
    email: 'anonimo@anonimo.com',
  };

  const logoutCustomer = async () => {
    if (global.isToten) {
      if (logoutAdminPopup) {
        const anonymousUser = await getAnonymousUser();
        localStorage.setItem(
          'userMenu',
          JSON.stringify({ id: anonymousUser.id, name: anonymousUser.name }),
        );
        return;
      }
      setLogoutAdminPopup(true);
    } else {
      localStorage.removeItem('userMenu');
      global.setAuthorizated(false);
      navigate('create-customer');
    }
  };

  function grabClient() {
    if (localStorage.hasOwnProperty('userMenu')) {
      const nameCustomer = JSON.parse(localStorage.getItem('userMenu'));

      if (nameCustomer.name === 'anonimo') {
        deleteAnonymousWithnoItem(nameCustomer.id);
      }

      let firstName = nameCustomer.name.split(' ')[0];
      firstName =
        firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
      setNameClient(firstName);
    }
  }

  const deleteAnonymousWithnoItem = (id) => {
    // Delete customer loged as anonimo and during 2 minutes does not have requestlog like anonimo and during 2 min does not have request
    setTimeout(async () => {
      try {
        const data = await getOneItemColleciton('user', id);
        if (!data?.request || data?.request.length === 0) {
          await deleteData('user', id);
          localStorage.removeItem('userMenu');
          global.setAuthorizated(false);
          CheckLogin();
        }
      } catch (error) {
        console.error('Erro ao buscar e deletar dados', error);
      }
    }, 1200000);
  };

  return (
    <>
      <div className="WarningMessage-container">
        {logoutAdminPopup && (
          <WarningMessage
            message="Você está prestes a sair do sistema"
            setWarningMsg={setLogoutAdminPopup}
            sendRequestToKitchen={logoutCustomer}
          />
        )}
      </div>

      <div ref={containerRef} style={{ height: '80vh', overflowY: 'auto' }}>
        {true && <CarrosselImages />}
        <div className={style.containerBtn}>
          <SubHeaderCustomer
            logoutCustomer={logoutCustomer}
            nameClient={nameClient}
            hasTable={Boolean(tableNumber)}
          />
          {menuButton &&
            dishes &&
            menuButton.map((item, index) => (
              <div key={index}>
                <NestedBtn
                  containerRef={containerRef}
                  parent={'main'}
                  item={item}
                  menuButton={menuButton}
                  dishes={dishes}
                  depth={0}
                />
              </div>
            ))}
        </div>
      </div>
      {/* Ponto cego de acesso ao admin (requer 5 cliques rápidos) */}
      <AdminBackdoor className={style.footer} />
    </>
  );
}
export default MainMenu;
